import { create } from 'zustand'
import cryptlib from "cryptlib"
import { GetCookie } from '../Action/GetCookie'
/**
 * Zustand state store برای مدیریت وضعیت درخواست API با رمزنگاری.
 * شامل وضعیت لودینگ، خطا، مارکت و دیتای دریافت‌شده.
 */
const useStore = create((set) => ({
    data: null,
    loading: false,
    error: null,
    market: true,
    fetchData: async (username, messageIds,_id) => {
        set({ loading: true, error: null })

        try {
            // const Market = IsIranian ? "WebAppZ" : "WebAppP";
            let VersionCode = 31226;
            let Token = GetCookie('Token')
            let arr = []

            arr.push(Number(messageIds))
            const user = { data: { 'username': username, 'messageIds': arr,_id } };
            let iv = '#GV^%^SUR&T*#Y*4'
            let key = cryptlib.getHashSha256('#GV^%^SUR&T*#Y*4', 32);
            // رمزنگاری دیتا
            const encryptedData = cryptlib.encrypt(JSON.stringify(user), key, iv);

            // درخواست POST با fetch
            // /main/v1/react/getreacts
            const response = await fetch('https://api.membersgram.com/main/v1/react/checkReactBeforePurchase', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    lan: '',
                    versionc: VersionCode,
                    market: 'google',
                    mainapitoken: Token
                },
                body: JSON.stringify({
                    data: encryptedData
                })
            });

            // خواندن خروجی به صورت متن (چون رمزنگاری شده است)
            const responseText = await response.text();
            // console.log(response)
            // رمزگشایی پاسخ
            const resultGetMember = JSON.parse(cryptlib.decrypt(responseText, key, iv));
            // console.log(resultGetMember)
            //   const res = await fetch('https://jsonplaceholder.typicode.com/posts/') // یک API تستی ساده
            //   if (!res.ok) throw new Error('خطا در دریافت داده')

            //   const json = await res.json()
            set({ data: resultGetMember, loading: false, })
            return resultGetMember
        } catch (err) {
            set({ error: err.message, loading: false, })
        }
    }
}))

export default useStore
